<template>
  <b-row>
    <b-col v-if="isLoading">
      <Loader size="lg"></Loader>
    </b-col>
    <b-col v-else>
      <b-row>
        <b-col>
          <router-link v-if="prevRoute.name === 'TimetableDashboard'" :to="{ name: 'TimetableDashboard' }" class="btn btn-default float-right">
            <span v-if="!mobileView">{{$t('buttons.backToCRM')}}</span>
            <i v-else class="far fa-arrow-alt-left"></i>
          </router-link>
          <router-link v-else :to="{ name: 'EXCMUserDataSalesOpportunityList' }" class="btn btn-default float-right">
            <span v-if="!mobileView">{{$t('buttons.backToList')}}</span>
            <i v-else class="far fa-arrow-alt-left"></i>
          </router-link>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-card>
<!--            <div class="card-header">-->
<!--              <h4 class="card-title">{{$t('views.excmuserdatasalesopportunity.update.title')}} {{ item && item['title'] }}</h4>-->
<!--            </div>-->
            <div class="card-body">
              <b-row>
                <b-col>
                  <EXCMUserDataSalesOpportunityForm
                          v-if="item"
                          :handle-submit="onSendForm"
                          :handle-update-field="updateField"
                          :values="item"
                          :errors="violations"
                          :initial-values="retrieved" />
                </b-col>
              </b-row>
            </div>
          </b-card>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import EXCMUserDataSalesOpportunityForm from './Form.vue'
import Loader from '../../Layout/Loader'

export default {
  components: {
    EXCMUserDataSalesOpportunityForm,
    Loader
  },

  data () {
    return {
      item: {},
      prevRoute: null
    }
  },
  beforeRouteEnter (to, from, next) {
    next((vm) => {
      vm.prevRoute = from
    })
  },
  computed: {
    mobileView () {
      return this.$store.state.mobileView
    },
    ...mapGetters({
      isLoading: 'excmuserdatasalesopportunity/update/isLoading',
      error: 'excmuserdatasalesopportunity/update/error',
      deleteError: 'excmuserdatasalesopportunity/del/error',
      deleteLoading: 'excmuserdatasalesopportunity/del/isLoading',
      created: 'excmuserdatasalesopportunity/create/created',
      deleted: 'excmuserdatasalesopportunity/del/deleted',
      retrieved: 'excmuserdatasalesopportunity/update/retrieved',
      updated: 'excmuserdatasalesopportunity/update/updated',
      violations: 'excmuserdatasalesopportunity/update/violations'
    })
  },

  watch: {
    // eslint-disable-next-line object-shorthand,func-names
    deleted: function (deleted) {
      if (!deleted) {
        return
      }

      this.$router.go(-1)
    },

    updated: function () {
      this.$router.go(-1)
    }
  },

  beforeDestroy () {
    this.reset()
  },

  created () {
    this.retrieve(decodeURIComponent(this.$route.params.id))
  },

  methods: {
    ...mapActions({
      createReset: 'excmuserdatasalesopportunity/create/reset',
      deleteItem: 'excmuserdatasalesopportunity/del/del',
      delReset: 'excmuserdatasalesopportunity/del/reset',
      retrieve: 'excmuserdatasalesopportunity/update/retrieve',
      updateReset: 'excmuserdatasalesopportunity/update/reset',
      update: 'excmuserdatasalesopportunity/update/update',
      updateRetrieved: 'excmuserdatasalesopportunity/update/updateRetrieved'
    }),

    del () {
      if (window.confirm('Are you sure you want to delete this excmuserdatasalesopportunity ?')) {
        this.deleteItem(this.retrieved)
      }
    },

    reset () {
      this.updateReset()
      this.delReset()
      this.createReset()
    },

    onSendForm () {
      this.update()
    },

    updateField (field, value) {
      this.updateRetrieved({ [field]: value })
    }
  }
}
</script>
